// extracted by mini-css-extract-plugin
export default {"productImage":"ProductItem_productImage__tM0l5","titleAndPrice":"ProductItem_titleAndPrice__4-IP8","productPrice":"ProductItem_productPrice__ZkhJC"};